// import example from "./example";
import expertEvaluate from "./expertEvaluate";
export default {
  getData: config => {
    const data = {};
    (data.data = {
      root: {
        showLeftMenu: null,
        code: "root",
        auth: false,
        pcode: "",
        auths: [],
        type: null,
        url: "",
        viewTemplate: "",
        sons: [
          // {
          //   showLeftMenu: 1,
          //   code: "100004",
          //   auth: false,
          //   pcode: "",
          //   auths: [],
          //   type: 1,
          //   url: "/list-query",
          //   viewTemplate: "common-modules/layout/Layout",
          //   sons: [
          //     {
          //       showLeftMenu: 1,
          //       code: "100005",
          //       auth: false,
          //       pcode: "100004",
          //       auths: [],
          //       type: 1,
          //       url: "/list-query/item-list",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "100006",
          //           auth: false,
          //           pcode: "100005",
          //           auths: [],
          //           type: 1,
          //           url: "/list-query/singleTab",
          //           viewTemplate: "common-modules/parent-view/index",
          //           sons: [
          //             {
          //               showLeftMenu: 1,
          //               code: "104498",
          //               auth: false,
          //               pcode: "100006",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/singleTab/item-list",
          //               viewTemplate: "example/listQuery/views/item-list",
          //               sons: [],
          //               name: "单表增删改查列表",
          //               id: 3622,
          //               isGroup: 0,
          //               keyword: "listQuery-item-list"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "104495",
          //               auth: false,
          //               pcode: "100006",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/singleTab/edit-item/:id",
          //               viewTemplate: "example/listQuery/views/edit-item",
          //               sons: [],
          //               name: "增删改查修改",
          //               id: 3619,
          //               isGroup: 0,
          //               keyword: "listQuery-edit-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "104496",
          //               auth: false,
          //               pcode: "100006",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/singleTab/item-detail/:id/:indexNum",
          //               viewTemplate: "example/listQuery/views/item-detail",
          //               sons: [],
          //               name: "增删改查详情",
          //               id: 3620,
          //               isGroup: 0,
          //               keyword: "listQuery-item-detail"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "104497",
          //               auth: false,
          //               pcode: "100006",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/singleTab/new-item",
          //               viewTemplate: "example/listQuery/views/new-item",
          //               sons: [],
          //               name: "增删改查新增",
          //               id: 3621,
          //               isGroup: 0,
          //               keyword: "listQuery-new-item"
          //             }
          //           ],
          //           name: "单表增删改查",
          //           id: 6,
          //           isGroup: 0,
          //           keyword: "listQuery-unit"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "100037",
          //           auth: false,
          //           pcode: "100005",
          //           auths: [],
          //           type: 1,
          //           url: "/list-query/peoplemanageSingleTab",
          //           viewTemplate: "common-modules/parent-view/index",
          //           sons: [
          //             {
          //               showLeftMenu: 1,
          //               code: "100038",
          //               auth: false,
          //               pcode: "100037",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanageSingleTab/item-list-all",
          //               viewTemplate:
          //                 "example/peoplemanageSingleTab/views/item-list-all",
          //               sons: [],
          //               name: "人员信息全部",
          //               id: 38,
          //               isGroup: 0,
          //               keyword: "peoplemanageSingleTab-tab-item-list-all"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100039",
          //               auth: false,
          //               pcode: "100037",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanageSingleTab/new-item",
          //               viewTemplate:
          //                 "example/peoplemanageSingleTab/views/new-item",
          //               sons: [],
          //               name: "人员信息新增",
          //               id: 39,
          //               isGroup: 0,
          //               keyword: "peoplemanageSingleTab-tab-new-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100040",
          //               auth: false,
          //               pcode: "100037",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanageSingleTab/edit-item/:id",
          //               viewTemplate:
          //                 "example/peoplemanageSingleTab/views/edit-item",
          //               sons: [],
          //               name: "人员信息新增编辑",
          //               id: 40,
          //               isGroup: 0,
          //               keyword: "peoplemanageSingleTab-tab-edit-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100041",
          //               auth: false,
          //               pcode: "100037",
          //               auths: [],
          //               type: 2,
          //               url:
          //                 "/list-query/peoplemanageSingleTab/item-detail/:id/:indexNum",
          //               viewTemplate:
          //                 "example/peoplemanageSingleTab/views/item-detail",
          //               sons: [],
          //               name: "人员信息新增详情",
          //               id: 41,
          //               isGroup: 0,
          //               keyword: "peoplemanageSingleTab-tab-item-detail"
          //             }
          //           ],
          //           name: "主子表增删改查",
          //           id: 37,
          //           isGroup: 0,
          //           keyword: "listQuery-peoplemanageSingleTab-item-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "100007",
          //           auth: false,
          //           pcode: "100005",
          //           auths: [],
          //           type: 1,
          //           url: "/list-query/tab",
          //           viewTemplate: "common-modules/parent-view/index",
          //           sons: [
          //             {
          //               showLeftMenu: 1,
          //               code: "100008",
          //               auth: false,
          //               pcode: "100007",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/tab/item-list-all",
          //               viewTemplate:
          //                 "example/singleTableTabPage/views/item-list-all",
          //               sons: [],
          //               name: "标签页示例所有",
          //               id: 8,
          //               isGroup: 0,
          //               keyword: "singleTableTabPage-tab-item-list-all"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "100009",
          //               auth: false,
          //               pcode: "100007",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/tab/item-list-opened",
          //               viewTemplate:
          //                 "example/singleTableTabPage/views/item-list-opened",
          //               sons: [],
          //               name: "标签页示例开启",
          //               id: 9,
          //               isGroup: 0,
          //               keyword: "singleTableTabPage-tab-item-list-opened"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "100010",
          //               auth: false,
          //               pcode: "100007",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/tab/item-list-closed",
          //               viewTemplate:
          //                 "example/singleTableTabPage/views/item-list-closed",
          //               sons: [],
          //               name: "标签页示例关闭",
          //               id: 10,
          //               isGroup: 0,
          //               keyword: "singleTableTabPage-tab-item-list-closed"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100011",
          //               auth: false,
          //               pcode: "100007",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/tab/new-item",
          //               viewTemplate:
          //                 "example/singleTableTabPage/views/new-item",
          //               sons: [],
          //               name: "标签页示例新增",
          //               id: 11,
          //               isGroup: 0,
          //               keyword: "singleTableTabPage-tab-new-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100012",
          //               auth: false,
          //               pcode: "100007",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/tab/edit-item/:id",
          //               viewTemplate:
          //                 "example/singleTableTabPage/views/edit-item",
          //               sons: [],
          //               name: "标签页示例编辑",
          //               id: 12,
          //               isGroup: 0,
          //               keyword: "singleTableTabPage-tab-edit-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100013",
          //               auth: false,
          //               pcode: "100007",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/tab/item-detail/:id",
          //               viewTemplate:
          //                 "example/singleTableTabPage/views/item-detail",
          //               sons: [],
          //               name: "标签页示例详情",
          //               id: 13,
          //               isGroup: 0,
          //               keyword: "singleTableTabPage-tab-item-detail"
          //             }
          //           ],
          //           name: "单表增删改查(多页签)",
          //           id: 7,
          //           isGroup: 0,
          //           keyword: "singleTableTabPage-tab-item-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "100014",
          //           auth: false,
          //           pcode: "100005",
          //           auths: [],
          //           type: 1,
          //           url: "/list-query/peoplemanage",
          //           viewTemplate: "common-modules/parent-view/index",
          //           sons: [
          //             {
          //               showLeftMenu: 1,
          //               code: "100015",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanage/item-list-all",
          //               viewTemplate:
          //                 "example/peoplemanage/views/item-list-all",
          //               sons: [],
          //               name: "人员信息全部",
          //               id: 15,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-item-list-all"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "100016",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanage/item-list-onthejob",
          //               viewTemplate:
          //                 "example/peoplemanage/views/item-list-onthejob",
          //               sons: [],
          //               name: "人员信息在职在岗",
          //               id: 16,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-item-list-onthejob"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "100017",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanage/item-list-onjobbutleave",
          //               viewTemplate:
          //                 "example/peoplemanage/views/item-list-onjobbutleave",
          //               sons: [],
          //               name: "人员信息在职离岗",
          //               id: 17,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-item-list-onjobbutleave"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "100018",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanage/item-list-leavejob",
          //               viewTemplate:
          //                 "example/peoplemanage/views/item-list-leavejob",
          //               sons: [],
          //               name: "人员信息离职离岗",
          //               id: 18,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-item-list-leavejob"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100019",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanage/new-item",
          //               viewTemplate: "example/peoplemanage/views/new-item",
          //               sons: [],
          //               name: "人员信息新增",
          //               id: 19,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-new-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100020",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url: "/list-query/peoplemanage/edit-item/:id",
          //               viewTemplate: "example/peoplemanage/views/edit-item",
          //               sons: [],
          //               name: "人员信息新增编辑",
          //               id: 20,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-edit-item"
          //             },
          //             {
          //               showLeftMenu: 0,
          //               code: "100021",
          //               auth: false,
          //               pcode: "100014",
          //               auths: [],
          //               type: 2,
          //               url:
          //                 "/list-query/peoplemanage/item-detail/:id/:indexNum",
          //               viewTemplate: "example/peoplemanage/views/item-detail",
          //               sons: [],
          //               name: "人员信息新增详情",
          //               id: 21,
          //               isGroup: 0,
          //               keyword: "peoplemanage-tab-item-detail"
          //             }
          //           ],
          //           name: "主子表增删改查(多页签)",
          //           id: 14,
          //           isGroup: 0,
          //           keyword: "listQuery-peoplemanage"
          //         }
          //       ],
          //       name: "增删改查",
          //       id: 5,
          //       isGroup: 0,
          //       keyword: "listQuery-item-list-index"
          //     },
          //     {
          //       showLeftMenu: 1,
          //       code: "104493",
          //       auth: false,
          //       pcode: "100004",
          //       auths: [],
          //       type: 1,
          //       url: "/list-query/consult",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "104494",
          //           auth: false,
          //           pcode: "104493",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/consult",
          //           viewTemplate: "example/consult/view/consult-list",
          //           sons: [],
          //           name: "参照列表",
          //           id: 3618,
          //           isGroup: 0,
          //           keyword: "listQuery-consult-list"
          //         }
          //       ],
          //       name: "参照样例",
          //       id: 3617,
          //       isGroup: 0,
          //       keyword: "listQuery-consult"
          //     },
          //     {
          //       showLeftMenu: 1,
          //       code: "100025",
          //       auth: false,
          //       pcode: "100004",
          //       auths: [],
          //       type: 1,
          //       url: "/list-query/goodsManage",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "100026",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/goodsManage",
          //           viewTemplate: "example/goodsManage/views/goods-list",
          //           sons: [],
          //           name: "商品管理",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-goods-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "100025011",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/ccui-table-input-list",
          //           viewTemplate:
          //             "example/contractManage/views/ccui-table-input-list.vue",
          //           sons: [],
          //           name: "CCUI表格",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-ccui-table-input-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250111",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/vxe-table-one-input-list",
          //           viewTemplate:
          //             "example/contractManage/views/vxe-table-one-input-list.vue",
          //           sons: [],
          //           name: "VXE表格",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-vxe-table-one-input-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250112",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-input-vue-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-input-vue-list.vue",
          //           sons: [],
          //           name: "原生Vue多行编辑",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-input-vue-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250112-1",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-input-vue-simple-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-input-vue-simple-list",
          //           sons: [],
          //           name: "原生最简Vue多行编辑",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-input-vue-simple-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250112-1-0",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url:
          //             "/list-query/origin-table-input-vue-simple-change-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-input-vue-simple-change-list",
          //           sons: [],
          //           name: "原生最简Vue多行编辑change",
          //           id: 26,
          //           isGroup: 0,
          //           keyword:
          //             "listQuery-origin-table-input-vue-simple-change-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250112-1-1",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url:
          //             "/list-query/origin-table-input-vue-simple-single-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-input-vue-simple-single-list",
          //           sons: [],
          //           name: "原生最简Vue多行编辑单向",
          //           id: 26,
          //           isGroup: 0,
          //           keyword:
          //             "listQuery-origin-table-input-vue-simple-single-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "10002501121",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-one-input-vue-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-one-input-vue-list.vue",
          //           sons: [],
          //           name: "原生Vue单行编辑静态",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-one-input-vue-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "100025011211",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-one-input-vue-dynamic-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-one-input-vue-dynamic-list",
          //           sons: [],
          //           name: "原生Vue单行编辑",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-one-input-vue-dynamic-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250113",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-input-jquery-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-input-jquery-list.vue",
          //           sons: [],
          //           name: "原生jQuery多行编辑",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-input-jquery-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250114",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-one-input-jquery-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-one-input-jquery-list.vue",
          //           sons: [],
          //           name: "原生jQuery单行编辑静态",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-one-input-jquery-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "10002501141",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url:
          //             "/list-query/origin-table-one-input-jquery-dynamic-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-one-input-jquery-dynamic-list",
          //           sons: [],
          //           name: "原生jQuery单行编辑",
          //           id: 26,
          //           isGroup: 0,
          //           keyword:
          //             "listQuery-origin-table-one-input-jquery-dynamic-list"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "1000250116",
          //           auth: false,
          //           pcode: "100025",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/origin-table-wucai-html-list",
          //           viewTemplate:
          //             "example/contractManage/views/origin-table-wucai-html-list",
          //           sons: [],
          //           name: "原生物采HTML",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-origin-table-wucai-html-list"
          //         }
          //       ],
          //       name: "UI样例",
          //       id: 25,
          //       isGroup: 0,
          //       keyword: "listQuery-goodsManage"
          //     },
          //     {
          //       showLeftMenu: 1,
          //       code: "1000051",
          //       auth: false,
          //       pcode: "100005",
          //       auths: [],
          //       type: 1,
          //       url: "/gantt-chart",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "10000502",
          //           auth: false,
          //           pcode: "1000051",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/gantt-chart",
          //           viewTemplate: "example/ganttChart/view/gantt-chart",
          //           sons: [],
          //           name: "甘特图列表",
          //           id: 41,
          //           isGroup: 0,
          //           keyword: "listQuery-gantt-chart"
          //         },
          //         {
          //           showLeftMenu: 0,
          //           code: "10000503",
          //           auth: false,
          //           pcode: "1000052",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/gantt-chart-add",
          //           viewTemplate: "example/ganttChart/view/gantt-chart-add",
          //           sons: [],
          //           name: "甘特图查看",
          //           id: 42,
          //           isGroup: 0,
          //           keyword: "listQuery-gantt-chart-add"
          //         }
          //       ],
          //       name: "甘特图",
          //       id: 39,
          //       isGroup: 0,
          //       keyword: "listQuery-gantt-chart"
          //     },
          //     {
          //       showLeftMenu: 1,
          //       code: "100051",
          //       auth: false,
          //       pcode: "100004",
          //       auths: [],
          //       type: 1,
          //       url: "/list-query/fine-report",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "10005101",
          //           auth: false,
          //           pcode: "100051",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/fine-report",
          //           viewTemplate: "example/fineReport/views/fine-report",
          //           sons: [],
          //           name: "开发人员查询",
          //           id: 26,
          //           isGroup: 0,
          //           keyword: "listQuery-fine-report-page"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "10005102",
          //           auth: false,
          //           pcode: "100051",
          //           auths: [],
          //           type: 2,
          //           url: "/list-query/fine-report-report",
          //           viewTemplate: "example/fineReport/views/fine-report-report",
          //           sons: [],
          //           name: "开发人员报表",
          //           id: 91,
          //           isGroup: 0,
          //           keyword: "listQuery-fine-report-report-page"
          //         }
          //       ],
          //       name: "帆软样例",
          //       id: 25,
          //       isGroup: 0,
          //       keyword: "listQuery-fine-report"
          //     }
          //   ],
          //   name: "功能样例",
          //   id: 4,
          //   isGroup: 0,
          //   keyword: "listQuery"
          // },
          // ...example,
          // {
          //   showLeftMenu: 1,
          //   code: "100033",
          //   auth: false,
          //   pcode: "",
          //   auths: [],
          //   type: 1,
          //   url: "/inquiry",
          //   viewTemplate: "common-modules/layout/Layout",
          //   sons: [
          //     {
          //       showLeftMenu: 1,
          //       code: "100034",
          //       auth: false,
          //       pcode: "100033",
          //       auths: [],
          //       type: 1,
          //       url: "/inquiry/inquiry-collect",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "100035",
          //           auth: false,
          //           pcode: "100034",
          //           auths: [],
          //           type: 2,
          //           url: "/inquiry/inquiry-collect",
          //           viewTemplate: "inquiry/views/inquiry-collect",
          //           sons: [],
          //           name: "询价定投统计表",
          //           id: 35,
          //           isGroup: 0,
          //           keyword: "inquiry-collect"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "100036",
          //           auth: false,
          //           pcode: "100034",
          //           auths: [],
          //           type: 2,
          //           url: "/inquiry/product-purchase-collect",
          //           viewTemplate: "inquiry/views/product-purchase-collect",
          //           sons: [],
          //           name: "商品采购统计表",
          //           id: 36,
          //           isGroup: 0,
          //           keyword: "product-purchase-collect"
          //         }
          //       ],
          //       name: "询价采购",
          //       id: 34,
          //       isGroup: 0,
          //       keyword: "inquiry-index"
          //     }
          //   ],
          //   name: "统计报表",
          //   id: 33,
          //   isGroup: 0,
          //   keyword: "inquiry"
          // },
          // {
          //   showLeftMenu: 1,
          //   code: "100095",
          //   auth: false,
          //   pcode: "",
          //   auths: [],
          //   type: 1,
          //   url: "/powerManage",
          //   viewTemplate: "common-modules/layout/Layout",
          //   sons: [
          //     {
          //       showLeftMenu: 0,
          //       code: "100096",
          //       auth: false,
          //       pcode: "100095",
          //       auths: [],
          //       type: 1,
          //       url: "/powerManage/powerManageList",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 0,
          //           code: "100097",
          //           auth: false,
          //           pcode: "100096",
          //           auths: [],
          //           type: 2,
          //           url: "/powerManage/powerManageList",
          //           viewTemplate: "powerManage/views/powerManage-list",
          //           sons: [],
          //           name: "应用角色列表",
          //           id: 97,
          //           isGroup: 0,
          //           keyword: "powerManage-powerManageList"
          //         },
          //         {
          //           showLeftMenu: 0,
          //           code: "100098",
          //           auth: false,
          //           pcode: "100096",
          //           auths: [],
          //           type: 2,
          //           url: "/powerManage/powerManageMemberMaintain/:roleId",
          //           viewTemplate:
          //             "powerManage/views/powerManage-memberMaintain",
          //           sons: [],
          //           name: "成员维护",
          //           id: 98,
          //           isGroup: 0,
          //           keyword: "powerManage-powerManageMemberMaintain"
          //         },
          //         {
          //           showLeftMenu: 0,
          //           code: "100099",
          //           auth: false,
          //           pcode: "100096",
          //           auths: [],
          //           type: 2,
          //           url: "/powerManage/powerManageMaintain/:roleId/:roleType",
          //           viewTemplate: "powerManage/views/powerManage-maintain",
          //           sons: [],
          //           name: "权限维护",
          //           id: 99,
          //           isGroup: 0,
          //           keyword: "powerManage-powerManageMaintain"
          //         }
          //       ],
          //       name: "应用角色列表主页",
          //       id: 96,
          //       isGroup: 0,
          //       keyword: "powerManage-index"
          //     }
          //   ],
          //   name: "权限管理",
          //   id: 95,
          //   isGroup: 0,
          //   keyword: "powerManage"
          // },
          // {
          //   showLeftMenu: 1,
          //   code: "104499",
          //   auth: false,
          //   pcode: "",
          //   auths: [],
          //   type: 1,
          //   url: "/baseOpera",
          //   viewTemplate: "common-modules/layout/Layout",
          //   sons: [
          //     {
          //       showLeftMenu: 1,
          //       code: "104501",
          //       auth: false,
          //       pcode: "104499",
          //       auths: [],
          //       type: 1,
          //       url: "/baseOpera/baseOperaList",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "104502",
          //           auth: false,
          //           pcode: "104501",
          //           auths: [],
          //           type: 1,
          //           url: "/baseOpera/supplierClass",
          //           viewTemplate: "common-modules/parent-view/index",
          //           sons: [
          //             {
          //               showLeftMenu: 1,
          //               code: "104512",
          //               auth: false,
          //               pcode: "104502",
          //               auths: [],
          //               type: 2,
          //               url:
          //                 "/baseOpera/supplierClass/supplierClassEngineering",
          //               viewTemplate:
          //                 "baseOpera/views/supplierClass/supplierClassEngineering",
          //               sons: [],
          //               name: "工程类",
          //               id: 3636,
          //               isGroup: 0,
          //               keyword:
          //                 "baseOpera-supplierClass-supplierClassEngineering"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "104513",
          //               auth: false,
          //               pcode: "104502",
          //               auths: [],
          //               type: 2,
          //               url: "/baseOpera/supplierClass/supplierClassMaterials",
          //               viewTemplate:
          //                 "baseOpera/views/supplierClass/supplierClassMaterials",
          //               sons: [],
          //               name: "物资类",
          //               id: 3637,
          //               isGroup: 0,
          //               keyword:
          //                 "baseOpera-supplierClass-supplierClassMaterials"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "104514",
          //               auth: false,
          //               pcode: "104502",
          //               auths: [],
          //               type: 2,
          //               url: "/baseOpera/supplierClass/supplierClassService",
          //               viewTemplate:
          //                 "baseOpera/views/supplierClass/supplierClassService",
          //               sons: [],
          //               name: "服务类",
          //               id: 3638,
          //               isGroup: 0,
          //               keyword: "baseOpera-supplierClass-supplierClassService"
          //             }
          //           ],
          //           name: "分包商分类",
          //           id: 3626,
          //           isGroup: 0,
          //           keyword: "baseOpera-supplierClass"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "104503",
          //           auth: false,
          //           pcode: "104501",
          //           auths: [],
          //           type: 1,
          //           url: "/baseOpera/supplierGrade",
          //           viewTemplate: "common-modules/parent-view/index",
          //           sons: [
          //             {
          //               showLeftMenu: 1,
          //               code: "104515",
          //               auth: false,
          //               pcode: "104503",
          //               auths: [],
          //               type: 2,
          //               url:
          //                 "/baseOpera/supplierGrade/supplierGradeEngineering",
          //               viewTemplate:
          //                 "baseOpera/views/supplierGrade/supplierGradeEngineering",
          //               sons: [],
          //               name: "分包商等级工程类",
          //               id: 3639,
          //               isGroup: 0,
          //               keyword:
          //                 "baseOpera-supplierGrade-supplierGradeEngineering"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "104516",
          //               auth: false,
          //               pcode: "104503",
          //               auths: [],
          //               type: 2,
          //               url: "/baseOpera/supplierGrade/supplierGradeMaterials",
          //               viewTemplate:
          //                 "baseOpera/views/supplierGrade/supplierGradeMaterials",
          //               sons: [],
          //               name: "分包商分类物资类",
          //               id: 3640,
          //               isGroup: 0,
          //               keyword:
          //                 "baseOpera-supplierGrade-supplierGradeMaterials"
          //             },
          //             {
          //               showLeftMenu: 1,
          //               code: "104517",
          //               auth: false,
          //               pcode: "104503",
          //               auths: [],
          //               type: 2,
          //               url: "/baseOpera/supplierGrade/supplierGradeService",
          //               viewTemplate:
          //                 "baseOpera/views/supplierGrade/supplierGradeService",
          //               sons: [],
          //               name: "分包商分类服务类",
          //               id: 3641,
          //               isGroup: 0,
          //               keyword: "baseOpera-supplierGrade-supplierGradeService"
          //             }
          //           ],
          //           name: "分包商等级",
          //           id: 3627,
          //           isGroup: 0,
          //           keyword: "baseOpera-supplierGrade"
          //         }
          //       ],
          //       name: "基础数据",
          //       id: 3625,
          //       isGroup: 0,
          //       keyword: "baseOpera-baseOperaList"
          //     }
          //   ],
          //   name: "基础数据",
          //   id: 3623,
          //   isGroup: 0,
          //   keyword: "baseOpera"
          // },
          // {
          //   showLeftMenu: 1,
          //   code: "104500",
          //   auth: false,
          //   pcode: "",
          //   auths: [],
          //   type: 1,
          //   url: "/appSet",
          //   viewTemplate: "common-modules/layout/Layout",
          //   sons: [
          //     {
          //       showLeftMenu: 1,
          //       code: "104518",
          //       auth: false,
          //       pcode: "104500",
          //       auths: [],
          //       type: 1,
          //       url: "/appSet/appSetClass",
          //       viewTemplate: "",
          //       sons: [
          //         {
          //           showLeftMenu: 1,
          //           code: "104519",
          //           auth: false,
          //           pcode: "104518",
          //           auths: [],
          //           type: 2,
          //           url: "/appSet/supplierClassMode",
          //           viewTemplate: "appSet/views/supplierClassMode",
          //           sons: [],
          //           name: "分包商分类",
          //           id: 3643,
          //           isGroup: 0,
          //           keyword: "appSet-appSetClass-supplierClassMode"
          //         },
          //         {
          //           showLeftMenu: 1,
          //           code: "104520",
          //           auth: false,
          //           pcode: "104518",
          //           auths: [],
          //           type: 2,
          //           url: "/appSet/supplierGradeMode",
          //           viewTemplate: "appSet/views/supplierGradeMode",
          //           sons: [],
          //           name: "分包商等级",
          //           id: 3644,
          //           isGroup: 0,
          //           keyword: "appSet-appSetClass-supplierGradeMode"
          //         }
          //       ],
          //       name: "应用设置",
          //       id: 3642,
          //       isGroup: 0,
          //       keyword: "appSet-appSetClass"
          //     }
          //   ],
          //   name: "应用设置",
          //   id: 3624,
          //   isGroup: 0,
          //   keyword: "appSet"
          // },
          ...expertEvaluate
        ],
        name: "",
        id: null,
        isGroup: null,
        keyword: ""
      }
    }),
      (data.code = "0");
    data.message = "success";
    return data;
  }
};
